import angular from 'angular';

resizeService.$inject = [
  '$rootScope',
  '$window',
  '$location',
  '$timeout',
  'loggerService',
  'iframeService',
  'partnerService'
];

export default function resizeService($rootScope, $window, $location, $timeout, logger, iframeService, partnerService) {
  class ResizeService {
    resizeToElementHeight(elementSelector, minHeight) { //eslint-disable-line
      const targetOrigin = partnerService.partner ? partnerService.partner.targetOrigin : null;

      $timeout(() => {
        const $el = angular.element(elementSelector);

        const outerHeight = $el.outerHeight();

        const message = {
          eventType: 'setHeight',
          height: minHeight && outerHeight < minHeight ? minHeight : outerHeight
        };

        iframeService.postMessage(message, targetOrigin);
      });
    }
  }

  return new ResizeService();
}



// WEBPACK FOOTER //
// ./src/services/resizeService.js